import { Timezones } from "@epcnetwork/core-ui-kit";

export const DEFAULT_TIME_ZONE: Timezones = "America/New_York";
